export class HerkunftsbetriebFilter {
    herkunft_kunde_id: number;
    herkunft_betrieb: string;
    herkunft_vvvo: string;
    anzahl: number;
}
